<template>
    <v-dialog v-model="showDialog"
              class="date-range-dialog"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="date-time-form text-primary ma-0">
            <v-card-title>
                Выбор диапазона дат
            </v-card-title>

            <v-card-text class="pa-2 ma-0">
                <div>
                    <v-radio-group v-model="rangeVariant"
                                   :inline="gridName !== 'xs' && gridName !== 'sm'">
                        <v-radio label="любой" :value="0" />
                        <v-radio label="1 день" :value="1" />
                        <v-radio label="3 дня" :value="3" />
                        <v-radio label="1 неделя" :value="7" />
                        <v-radio label="2 недели" :value="14" />
                        <v-radio label="1 месяц" :value="30" />
                    </v-radio-group>
                </div>
                <div class="d-flex flex-column flex-sm-column flex-md-row">
                    <v-date-picker v-model="startDate"
                                   show-adjacent-months
                                   title="Начало"
                                   header="Выберите дату"
                                   class="text-primary my-2 my-sm-2 mx-md-2"
                                   color="primary" />
                    <v-date-picker v-model="endDate"
                                   show-adjacent-months
                                   title="Конец"
                                   header="Выберите дату"
                                   class="text-primary my-2 my-sm-2 mx-md-2"
                                   color="primary" />
                </div>
            </v-card-text>

            <v-card-actions class="pb-md-4 px-md-4">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!startDate && !endDate"
                       @click="reset">Сбросить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!startDate || !endDate"
                       @click="save">Применить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {

        },

        props: {
            modelValue: Object
        },

        emits: ["update:modelValue", "hide"],

        data() {
            return {
                showDialog: true,

                startDate: this.modelValue?.startDate,
                endDate: this.modelValue?.endDate,

                rangeVariant: 0,

                currentDaysCont: null
            };
        },

        mounted() {
            this.currentDaysCont = this.getCurrentDaysCont(this.startDate, this.endDate);
        },

        computed: {
            gridName() {
                return this.$vuetify.display.name;
            },

            suggestedDaysCont() {
                switch (this.rangeVariant) {
                    case 0:
                    case 1:
                    case 3:
                    case 7:
                    case 14:
                        return this.rangeVariant;
                }

                if (this.rangeVariant !== 30) {
                    return 0;
                }

                if (!this.startDate || !this.startDate.month) {
                    return 30;
                }

                switch (this.startDate.month) {
                    case 1:
                    case 3:
                    case 5:
                    case 7:
                    case 8:
                    case 10:
                    case 12:
                        return 31;
                    default:
                        return 30;
                }
            }
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            },

            startDate(newValue) {
                if (!newValue) {
                    return;
                }
                if (this.suggestedDaysCont === 0) {
                    return;
                }

                this.endDate = newValue.plus({ days: this.suggestedDaysCont - 1 });
            },

            endDate(newValue) {
                this.currentDaysCont = this.getCurrentDaysCont(this.startDate, newValue);
            },

            suggestedDaysCont(newValue) {
                if (newValue === 0) {
                    return;
                }
                if (!this.startDate) {
                    return;
                }

                this.endDate = this.startDate.plus({ days: newValue - 1 });
            },

            currentDaysCont(newValue) {
                if (!newValue) {
                    return;
                }

                switch (newValue) {
                    case 1:
                    case 3:
                    case 7:
                    case 14:
                    case 30:
                        this.rangeVariant = newValue;
                        return;
                    case 31:
                        this.rangeVariant = 30;
                        return;
                }

                this.rangeVariant = 0;
            }
        },

        methods: {
            getCurrentDaysCont(startDate, endDate) {
                if (!startDate || !endDate) {
                    return null;
                }
                if (startDate.startOf("day") > endDate.startOf("day")) {
                    return null;
                }

                return endDate.diff(startDate, "days").days + 1;
            },

            reset() {
                this.startDate = null;
                this.endDate = null;
                this.$emit("update:modelValue", null);
            },

            save() {
                if (!this.startDate || !this.endDate) {
                    return;
                }

                if (this.startDate.startOf("day") > this.endDate.startOf("day")) {
                    const temp = this.startDate;
                    this.startDate = this.endDate;
                    this.endDate = temp;
                    return;
                }

                this.$emit("hide");
                this.$emit("update:modelValue", {
                    startDate: this.startDate,
                    endDate: this.endDate
                });
            }
        }
    };
</script>

<style lang="scss">
    .date-range-dialog {
    }
</style>